import React, { useState } from "react";
import { Row, Col, Card, Menu, Dropdown, Button } from "antd";
import { BsThreeDotsVertical } from "react-icons/bs";
import CustomModal from "../modals/customModal";
import "./index.css";
import Delete_order from "../../assets/images/delete_order.png";

const Tag = ({ status }) => {
  return (
    <div
      style={{
        border: status === "Active" ? "1px solid lightgreen" : "1px solid red",
      }}
    >
      <span
        style={{
          color: status === "Active" ? "lightgreen" : "red",
          textTransform: "uppercase",
        }}
      >
        {status}
      </span>
    </div>
  );
};

const Employe_Card = ({ item, onEdit, updateUser, status, userId }) => {
  const [isOpenModal, setModal] = useState(false);
  const menu = (
    <Menu style={{ width: 0, padding: 0 }} className="menu-fit">
      <Menu.Item key="0" onClick={() => onEdit(item)}>
        <span className="st-primary">Edit</span>
      </Menu.Item>
      {/* updateUser({}, null, userId, status !== "active" ? "Activate" : "Deactivate") */}
      <Menu.Divider />
      <Menu.Item
        key="1"
        onClick={() => {
          status == "active"
            ? setModal(true)
            : updateUser(
                () => setModal(false),
                null,
                userId,
                status == "active" ? "Deactivate " : "Activate"
              );
        }}
      >
        <span className="st-primary">
          {status !== "active" ? "Activate" : "Deactivate"}
        </span>
      </Menu.Item>
    </Menu>
  );
  return (
    <Row justify="center">
      <Col
        sm={20}
        md={20}
        lg={22}
        xl={23}
        xs={24}
        style={{ margin: "1rem" }}
        className="col-card"
      >
        <Card
          className="custom-card "
          style={{
            minHeight: "13rem",
            maxHeight: "14rem",
          }}
        >
          <Row justify="space-around">
            <Col xs={20} sm={20} md={20} lg={20} xl={20}>
              <Row align="middle" justify="space-between">
                <Col xs={10} sm={8} md={9} lg={8} xl={8}>
                  <img
                    height="50"
                    width="50"
                    className="border-rounded"
                    src={item?.image?.original}
                    style={{ objectFit: "cover" }}
                  />
                </Col>
                <Col
                  style={{ fontSize: "14px" }}
                  xs={14}
                  sm={16}
                  md={15}
                  lg={16}
                  xl={16}
                >
                  <Row justify="start">
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <p className="three-dot text-left">{`${
                        item.first_name || "-"
                      } ${item.last_name || "-"}`}</p>
                    </Col>
                    <Col xs={22} sm={16} md={16} lg={16} xl={16}>
                      <Tag
                        status={status == "active" ? "Active" : "Inactive"}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col span={4}>
              <Dropdown
                overlay={menu}
                trigger={["click"]}
                style={{ width: "40%" }}
              >
                <BsThreeDotsVertical className="pointer-cursor" />
              </Dropdown>
            </Col>
          </Row>
          <Row style={{ marginTop: "16px" }}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Row justify="space-between" gutter={[0, 10]}>
                <Col xl={4} lg={4} sm={4} xs={4} md={4}>
                  <span className="text-left card-key">Phone</span>
                </Col>
                <Col xl={17} lg={17} sm={12} xs={15} md={17}>
                  <span className="text-left three-dot  card-value">
                    {item.phone}
                  </span>
                </Col>
              </Row>
              <Row justify="space-between">
                <Col xl={3} lg={4} sm={4} xs={4} md={4}>
                  <span className="text-left card-key">Email</span>
                </Col>
                <Col xl={17} lg={17} sm={12} xs={15} md={17}>
                  <span className="text-left three-dot card-value ">
                    {item.email}
                  </span>
                </Col>
              </Row>
              <Row justify="space-between">
                <Col xl={4} lg={4} sm={4} xs={4} md={4}>
                  <span className="text-left  card-key">Address</span>
                </Col>
                <Col xl={17} lg={17} sm={12} xs={15} md={17}>
                  <span className="text-left three-dot card-value ">
                    {item.address}
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </Col>
      <CustomModal
        visible={isOpenModal}
        onCancelModal={() => setModal(false)}
        footer={[
          <Row justify="center" style={{ margin: "20px" }}>
            <Col
              className="d-flex justify-content-center"
              style={{ width: "100%" }}
            >
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() =>
                  updateUser(
                    () => setModal(false),
                    null,
                    userId,
                    status == "active" ? "Deactivate " : "Activate"
                  )
                }
              >
                YES
              </Button>
              <Button
                style={{
                  backgroundColor: "#26a69a ",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() => setModal(false)}
              >
                NO
              </Button>
            </Col>
          </Row>,
        ]}
      >
        <Row justify="center">
          <Col className="d-flex justify-content-center" span={24}>
            <img src={Delete_order} />
          </Col>
          <Col span={24} style={{ textAlign: "center" }}>
            <span>{"Are you sure you want to deactivate this employee?"}</span>
          </Col>
        </Row>
      </CustomModal>
    </Row>
  );
};
export default Employe_Card;
